import {
  Directive,
  ElementRef,
  inject,
  Input,
  Renderer2
} from '@angular/core';

type LightColor = string;

@Directive({
  selector: '[itemLight]'
})
export class ItemLightDirective {
  private readonly elementRef = inject<ElementRef<HTMLElement>>(ElementRef);

  @Input()
  set itemLight(color: LightColor) {
    const { nativeElement } = this.elementRef;

    nativeElement.innerHTML = `<svg width="145" height="145" viewBox="0 0 145 145" fill="none" xmlns="http://www.w3.org/2000/svg"><g filter="url(#filter0_f_7599_24067)"><circle cx="72.5" cy="72.5" r="32.5" fill="#${ color }" fill-opacity="0.45"/></g><defs><filter id="filter0_f_7599_24067" x="0" y="0" width="145" height="145" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"/><feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/><feGaussianBlur stdDeviation="20" result="effect1_foregroundBlur_7599_24067"/></filter></defs></svg>`;
  }
}